import React, { useState } from 'react';
import { CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { GridHighlightDescriptor } from '@progress/kendo-react-grid';
import Grid from '@components-clean/core/grid-fe';
import { GridColumns } from '@pages-clean/dummy-page/pages/highlight-grid-poc/columns';
import { GridData } from '@pages-clean/dummy-page/pages/highlight-grid-poc/data';

const HighlightGridPocPage = () => {
    const DATA_ITEM_KEY: string = 'ProductID';
    const [highlight, setHighlight] = useState<GridHighlightDescriptor>();

    const getHighlightFromResults = (
        dataItems: {
            ProductID: number;
            Title: string;
            Description: string;
            datasetDate: string;
            reviewedStatus: string;
            isActive: boolean;
            score: { colour: string; score: number };
        }[],
        dataItemKey?: string | undefined,
    ) => {
        return dataItems.reduce(
            (acc, item) => {
                const dataItem = (item as unknown as { [k in string]: never })[dataItemKey ?? 'id'] as string;
                acc[dataItem] = true;
                return acc;
            },
            {} as Record<string, boolean>,
        );
    };

    const getHighlightedItems = (
        data: {
            ProductID: number;
            Title: string;
            Description: string;
            datasetDate: string;
            reviewedStatus: string;
            isActive: boolean;
            score: { colour: string; score: number };
        }[],
        filters: CompositeFilterDescriptor,
        dataItemKey?: string,
    ) => {
        return getHighlightFromResults(filterBy(data, filters), dataItemKey);
    };

    return (
        <>
            <div style={{ height: '100px', marginBottom: '20px' }}>
                <Grid
                    title="Apply Highlight Filters Here"
                    maxHeight="auto"
                    testDataId="highlight-poc-filter-grid"
                    dataItemKey={DATA_ITEM_KEY}
                    columns={GridColumns}
                    highlight={highlight}
                    canEdit={false}
                    clearFilter={async () => {
                        setHighlight({});
                    }}
                    showAddIcon={false}
                    onFilterChange={async (event) => {
                        const { filter } = event;
                        if (filter) {
                            setHighlight(getHighlightedItems(GridData, filter, DATA_ITEM_KEY));
                        } else setHighlight({});
                    }}
                />
            </div>
            <div style={{ height: 'calc(100vh - 280px)' }}>
                <Grid
                    title="Highlight Rows Grid"
                    maxHeight="auto"
                    testDataId="highlight-poc-grid"
                    dataItemKey={DATA_ITEM_KEY}
                    data={GridData}
                    columns={GridColumns}
                    highlight={highlight}
                    canEdit={false}
                    showAddIcon={false}
                />
            </div>
        </>
    );
};

export default HighlightGridPocPage;
